import { Box, Heading, Icon, VStack, Text, Button, Image, useDisclosure } from '@chakra-ui/react';
import PageContainer from '~/containers/PageContainer';
import Content from '~/containers/Content';
import SectionContainer from '~/containers/SectionContainer';
import BackwardBar from '~/components/BackwardBar';
import { CreateGroupModal } from './components';
import { useNavigate } from 'react-router-dom';
import authAtom from '~/recoil/atom/auth';
import cartSelector from '~/recoil/selectors/cart';
import { useRecoilValue } from 'recoil';
import createGroupCart from '~/firebase/initialDoc/createGroupCart';
import { IoPeopleOutline } from 'react-icons/io5';
import { BtnVariant } from '~/theme/components/Button';
import { CartItem, CartStatus, CartType, MemberStoreCart } from '~/types/cart';
import groupImg from '~/assets/images/group.png';

export default function GroupBuyCreate() {
  const navigate = useNavigate();

  const auth = useRecoilValue(authAtom);
  const cart = useRecoilValue(cartSelector);

  const { isOpen, onClose, onOpen } = useDisclosure();

  const handleCreateGroupCart = async (note: string) => {
    if (!auth) return;

    // const groupCart = fp.extend<PlatformCart>(cart)({
    //   cartType: CartType.CART_GROUP,
    //   status: CartStatus.ACTIVE,
    //   uid: auth.uid,
    //   groupHostInfo: {
    //     name: auth.displayName || '',
    //     note: note,
    //   },
    //   orders: cart.orders.map((order) => ({
    //     ...order,
    //     items: [] as Array<CartItem>,
    //     groupItems: [
    //       { memberName: auth.displayName || '', memberId: auth.uid, items: order.items },
    //     ] as Array<MemberStoreCart>,
    //   })),
    // });

    const groupCart = {
      ...cart,
      cartType: CartType.CART_GROUP,
      status: CartStatus.ACTIVE,
      uid: auth.uid,
      groupHostInfo: {
        name: auth.displayName || '',
        note: note,
      },
      orders: cart.orders.map((order) => ({
        ...order,
        items: [] as Array<CartItem>,
        groupItems: [
          { memberName: auth.displayName || '', memberId: auth.uid, items: order.items },
        ] as Array<MemberStoreCart>,
      })),
    };

    try {
      const res = await createGroupCart(groupCart);
      navigate(`/group/${res.id}/groupBuy`);
    } catch (err) {
      console.error('create group cart error');
    }
  };

  return (
    <PageContainer hideHeader hideNavBar>
      <Box>
        <Content>
          <BackwardBar title="繼續結帳" onNavigate={() => navigate(-1)} />
          <Box borderBottomWidth="1px" borderColor="primary" py={2}>
            <Heading size="md" textAlign="center">
              揪團訂
            </Heading>
          </Box>
        </Content>
      </Box>
      <Box p={4}>
        <Content>
          <SectionContainer
            title="揪團訂"
            icon={<Icon as={IoPeopleOutline} color="secondary" boxSize="1.5rem" />}
          >
            <VStack>
              <Image src={groupImg} />
              <Text fontSize="xs" color="secondary">
                快揪人一起點餐吧
              </Text>
              <Button
                w="10rem"
                leftIcon={<Icon as={IoPeopleOutline} />}
                variant={BtnVariant.SOLID}
                onClick={onOpen}
              >
                揪團訂
              </Button>
            </VStack>
          </SectionContainer>
        </Content>
      </Box>
      <CreateGroupModal isOpen={isOpen} onClose={onClose} onConfirm={handleCreateGroupCart} />
    </PageContainer>
  );
}
